import { Card } from '@/components/ui/card';

const ExportsPage = () => (
  <div className="space-y-6">
    <div>
      <h2 className="text-2xl font-semibold text-white">Exports</h2>
      <p className="text-sm text-slate-400">Generate CSV/JSON datasets and retrieve signed URLs.</p>
    </div>

    <Card title="Generate Export">
      <p className="text-sm text-slate-400">Trigger the `reports-export` Edge Function with filters.</p>
    </Card>

    <Card title="History">
      <p className="text-sm text-slate-400">List recent exports with expiration and download links.</p>
    </Card>
  </div>
);

export default ExportsPage;
